import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from "react";
import { useMainMenuContext, useMainMenuTranslation } from "../../../../../hooks";
import MainMenuDrawer from "../../../../../ui/MainMenuDrawer";
import LeftMenuDrawerContent from "./LazyLeftMenuDrawerContent";
import { jsx as _jsx } from "react/jsx-runtime";
var LeftMenuDrawer = function LeftMenuDrawer(leftMenuDrawerProps) {
  var _useMainMenuTranslati = useMainMenuTranslation(),
    t = _useMainMenuTranslati.t;
  var _useMainMenuContext = useMainMenuContext(),
    activeSubMenu = _useMainMenuContext.activeSubMenu,
    onCloseSubmenu = _useMainMenuContext.onCloseSubmenu;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    activeDropdown = _useState2[0],
    setActiveDropdown = _useState2[1];
  var onDropwdownClose = function onDropwdownClose() {
    setActiveDropdown(undefined);
  };
  var onCategoriesDropdownOpen = function onCategoriesDropdownOpen() {
    setActiveDropdown('catalog');
  };
  var onResourcesDropdownOpen = function onResourcesDropdownOpen() {
    setActiveDropdown('resources');
  };
  var onDegreesDropdownOpen = function onDegreesDropdownOpen() {
    setActiveDropdown('degrees');
  };
  var onBlogCategoriesDropdownOpen = function onBlogCategoriesDropdownOpen() {
    setActiveDropdown('blogCategories');
  };
  var onSolutionsDropdownOpen = function onSolutionsDropdownOpen() {
    setActiveDropdown('solutions');
  };
  var onDismissLeftMenuDrawer = function onDismissLeftMenuDrawer() {
    onDropwdownClose();
    onCloseSubmenu();
  };
  return /*#__PURE__*/_jsx(MainMenuDrawer, {
    title: t('LEFT_MENU_TITLE'),
    isOpen: activeSubMenu === 'left-menu-drawer',
    onDismiss: onDismissLeftMenuDrawer,
    position: "left",
    children: /*#__PURE__*/_jsx(LeftMenuDrawerContent, _objectSpread(_objectSpread({}, leftMenuDrawerProps), {}, {
      activeDropdown: activeDropdown,
      onDropwdownClose: onDropwdownClose,
      onCategoriesDropdownOpen: onCategoriesDropdownOpen,
      onResourcesDropdownOpen: onResourcesDropdownOpen,
      onDegreesDropdownOpen: onDegreesDropdownOpen,
      onBlogCategoriesDropdownOpen: onBlogCategoriesDropdownOpen,
      onSolutionsDropdownOpen: onSolutionsDropdownOpen,
      onDismissLeftMenuDrawer: onDismissLeftMenuDrawer
    }))
  });
};
export default LeftMenuDrawer;